export const vendorsState = {
  vendorsFormStatus: false,
  vendorsGroupFormStatus: false,
  vendorsIsEdit: false,
  vendorsGroupIsEdit: false,
  vendorsSelectedForEdit: null,
   vendorsGroupSelectedForEdit: null,
  vendorManageable: false,
  vendorPermissionId:null, 
 
};